import Typography from '@ixigo/iui/Typography';

interface SectionHeaderProps {
	title: string;
	className?: string;
}

const SectionHeader = ({ title, className = '' }: SectionHeaderProps) => {
	return (
		<Typography variant="h5" fontWeight="medium" className={className}>
			{title}
		</Typography>
	);
};

export default SectionHeader;
